import { useEffect, useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import PageListPage from "./PageListPage";

export default ({ id, code, name, list, pageLists }) => {
  const [listFormOpened, setListFormOpened] = useState(false);
  const [selectedList, setSelectedList] = useState(null);
  const [listSelectionOpened, setListSelectionOpened] = useState(false);

  // handle page edit redirect
  const CREATE_EDITOR_LOGIN_CODE = gql`
    mutation CreateEditorLoginCode {
      createEditorLoginCode {
        resultCode
        code
      }
    }
  `;

  const [createEditorLoginCode] = useMutation(CREATE_EDITOR_LOGIN_CODE);

  const onEditClick = async (pageCode) => {
    console.log("Logging into editor", pageCode);

    const result = await createEditorLoginCode({});

    console.log("result", result);

    window
      .open(
        `http://localhost:5173/editor-login?code=${result.data.createEditorLoginCode.code}&page=${pageCode}`,
        "_blank"
      )
      .focus();
  };

  // handle Maling list settings
  useEffect(() => {
    setSelectedList(JSON.stringify(list));
  }, [list]);

  const changeListToggle = () => {
    setListFormOpened((prevState) => !prevState);
  };

  const toggleListSelection = () => {
    setListSelectionOpened((prevState) => !prevState);
  };

  const onListSelect = (list) => {
    setSelectedList(JSON.stringify(list));
    setListSelectionOpened(false);
  };

  console.log("pageLists", pageLists);

  return (
    <>
      <PageListPage
        id={id}
        code={code}
        name={name}
        list={list}
        pageLists={pageLists}
        onEditClick={onEditClick}
        changeListToggle={changeListToggle}
        listFormOpened={listFormOpened}
        selectedList={JSON.parse(selectedList)}
        listSelectionOpened={listSelectionOpened}
        toggleListSelection={toggleListSelection}
        onListSelect={onListSelect}
      />
    </>
  );
};
